module.exports = __webpack_public_path__ + "static/media/info_06.f507f468.jpg";